
export default {
  productData: {
    serialNumber: 'DA-MMEU-003',
    name: 'Massivholzdecke mit Estrich und Unterdecke l Aufbau 3',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Trockenestrichplatten mit integrierter Fußbodenheizung' },
          output: '20',
          value: 'd-20'
        },
        {
          type: 'suspendedCeilingA',
          title: { de: 'Gipsfaserplatten' },
          output: '10',
          value: 'gp-10'
        },
        {
          type: 'insulation',
          title: { de: 'Holzfaserdämmplatte WF<br>(<i>s‘</i> ≤ 20 MN/m<sup>3</sup>; Anwendungsgebiet DES-sg)' },
          output: '≥ 20',
          value: 'w-20'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 190 kg/m<sup>2</sup>), Rieselschutz' },
          output: '≥ 120',
          value: 'scsb-120'
        },
        {
          type: 'supportingStructure',
          title: { de: 'Massivholzdecke (Steico GLVL)' },
          output: 120,
          value: 'mh-120'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'U-Abhänger schallentkoppelt 60/27' },
          output: 80,
          value: 'uas-80'
        },
        {
          type: 'suspendedCeilingA',
          title: { de: 'Gipsplatte GKB' },
          output: '12,5',
          value: 'g-12.5'
        }
      ],
      sum: {
        output: '382,5', value: 382.5
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '45 (1; 8)',
        value: 45
      },
      soundReductionIndex: { // Rw
        output: '69 (-6; -14)',
        value: 69
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,50',
        value: 0.50
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '342 [kg/m²]'
      }
    }
  },
  image: 'da-mmeu-003.png',
  pdf: 'Massivholzdecke-mit-Estrich-und-Unterdecke-Aufbau-3-DA-MMEU-003-Rev01.pdf'
}
